<template>
    <div class="jcy-default-layout">
        <div class="jcy-main-wrapper" :style="backgroundStyle">
            <slot/>
        </div>
        <jcy-footer/>
    </div>
</template>

<script>
const COMPONENT_NAME = 'default-layout'
export default {
  name: COMPONENT_NAME,
  props: {
    backgroundColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    backgroundStyle () {
      if (this.backgroundColor) {
        return {
          background: this.backgroundColor
        }
      }
      return {}
    }
  }
}
</script>

<style lang="scss">
.jcy-default-layout {
    width: 100%;
    height: 100%;
    .jcy-main-wrapper {
        width: 100%;
        min-height: 100%;
        // min-height: calc(100% - px);
        padding-bottom: 100px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/default-layout.vue